<div class="row g-3 ">
	<!-- User Info Card -->


	<div class="col-12 col-md-12">
		<div class="card h-100">
			<div class="card-body">
				<h5 class="card-title">{{contentStrings['CommunityCalendar'][language]}}</h5>
				<div>
					<app-community-calendar></app-community-calendar>
				</div>
			</div>
		</div>
	</div>

</div>



<div class="row g-3 mt-1">
	<!-- User Info Card -->


</div>